import script from "./MonitorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorPage.vue?vue&type=script&setup=true&lang=js"

import "./MonitorPage.vue?vue&type=style&index=0&id=a20d3b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a20d3b2a"]])

export default __exports__